import { useEffect } from 'react';
import { useTankCleaningStore } from '../context/TankCleaningContext';
import { ChemicalRobPortCall } from '../types/ViewModel/TankCleaning/ROB/ChemicalRobPortCall';
import { createChemicalRobPortCall } from '../factory/TankCleaning/ChemicalRobPortCallFactory';
import { ChemicalRobPortCallBM } from '../types/BusinessModel/TankCleaning/ChemicalRobPortCallBM';
import useApi from './useApi';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import useApiEndpoints from '../context/useApiEndpoints';
import useUpdateMissingTasksIcon from '../app/useUpdateMissingTasksIcon';
import { AppFeatureEnum } from '../enums/appFeatureEnum';
import useAppFeature from '../app/useAppFeature';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { setSelectedChemicalRobForPortCall } = useTankCleaningStore();
    const { state, postApiData } = useApi();
    const { updateCargoConsumablesMissingTasks } = useUpdateMissingTasksIcon();
    const { isFeatureEnabled } = useAppFeature();

    const upsertChemicalRob = async (chemicalRobUpdateDto: ChemicalRobPortCallBM, imoNumber: number) =>
        await postApiData({
            endpoint: apiEndpoints['upsertChemicalRob'].url,
            data: chemicalRobUpdateDto,
            queryParam: buildQueryParams({ imoNumber: imoNumber }),
        });

    useEffect(() => {
        if (state.status === 'success') {
            if (state.endpoint === apiEndpoints['upsertChemicalRob'].url) {
                const _chemicalRobPortCall: ChemicalRobPortCall | null = createChemicalRobPortCall(state.result);
                if (_chemicalRobPortCall) {
                    setSelectedChemicalRobForPortCall({ ..._chemicalRobPortCall });
                }

                if (isFeatureEnabled({ featureEnum: AppFeatureEnum.Notifications, date: new Date() })) {
                    updateCargoConsumablesMissingTasks(_chemicalRobPortCall.imoNumber);
                }
            }
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return {
        upsertChemicalRob,
    };
};
